import { Col, Row } from 'antd'
import React, { useEffect } from 'react'
import { MdLock } from 'react-icons/md'
import '../../assets/styles/scss/pages/_login.scss'
import ButtonUC from '../../components/buttonUC'
import InputUC from '../../components/Form/InputUC'
import { useSetRecoilState } from 'recoil'
import { toggleLoginPopUpState } from '../../recoil/states/default'

const FormSignIn = (props) => {
    const { handleLogin } = props
    const rules =
        [
            {
                type: 'email',
                message: 'อีเมลไม่ถูกต้อง',
            },
            {
                required: true,
                message: 'กรุณากรอกอีเมล',
            },
        ]

    const setTogglePopUpLogin = useSetRecoilState(toggleLoginPopUpState)
    useEffect(() => {
        return () => {
            setTogglePopUpLogin(false)
            console.log('clear toggle state')
        }
    }, [])

    const handlePressEnter = (event) => {
        event.preventDefault()
        handleLogin()
    }

    return (
        <>
            <div className="icon-login">
                <MdLock />
            </div>
            <div className="title-login text-3xl text-center">เข้าสู่ระบบ / ลงทะเบียน</div>
            <div className="title-login text-center">โปรดระบุอีเมลเพื่อจัดการใบสมัคร</div>
            <Row className="py-2">
                <Col span={24} className='px-2'>
                    <InputUC label='อีเมล' name={'email_login'} rules={rules}
                        onPressEnter={handlePressEnter}
                    />
                </Col>
            </Row>
            <Row className="py-2 ">
                <Col span={24} className='px-2 text-center'>
                    <ButtonUC
                        style={{ width: '170px' }}
                        className='btn-custom'
                        onClick={handleLogin}
                    >ยืนยัน
                    </ButtonUC>
                </Col>
            </Row>
        </>
    )
}

export default FormSignIn
